const $ = require('jquery')
const parseUrl = require('locutus/php/url/parse_url')
const httpBuildQuery = require('locutus/php/url/http_build_query')
const queryString = require('query-string')

/**
 * Add cache control query param on all links.
 *
 * @param {string} url Url to decorate
 * @returns {string} Return decorated url
 */
function cacheControlForceLink(url) {
  const urlParts = parseUrl(url)
  const queryParts = typeof urlParts.query !== 'undefined' ? queryString.parse(urlParts.query) : {}

  // default path is `/`
  if (typeof urlParts.path === 'undefined') {
    urlParts.path = '/'
  }

  // Add force no-store cache-control query param
  queryParts[cacheControl.query_name] = 1

  // Create final URL
  const finalUrl = []

  if (typeof urlParts.host !== 'undefined') {
    if (typeof urlParts.scheme !== 'undefined') {
      finalUrl.push(urlParts.scheme, '://')
    } else if (url.substring(0, 2) == '//') {
      finalUrl.push('//')
    }

    if (typeof urlParts.user !== 'undefined' || typeof urlParts.pass !== 'undefined') {
      if (typeof urlParts.user !== 'undefined') {
        finalUrl.push(urlParts.user)
      }

      if (typeof urlParts.pass !== 'undefined') {
        finalUrl.push(':', urlParts.pass)
      }

      finalUrl.push('@')
    }

    finalUrl.push(urlParts.host)

    if (typeof urlParts.port !== 'undefined') {
      finalUrl.push(':', urlParts.port)
    }
  }

  finalUrl.push(urlParts.path, '?', httpBuildQuery(queryParts))

  if (typeof urlParts.fragment !== 'undefined') {
    finalUrl.push('#', urlParts.fragment)
  }

  return finalUrl.join('')
}

function cacheControlParseLinks() {
  const domainPattern = new RegExp(`^(${cacheControl.domains.join('|')})$`, 'i')

  $('a').each(function () {
    const href = $(this).attr('href')
    const urlParts = parseUrl(href)

    if (domainPattern.test(urlParts.host)) {
      $(this).attr('href', cacheControlForceLink(href))
    }
  })
}

function cacheControlParseForms() {
  const domainPattern = new RegExp(`^(${cacheControl.domains.join('|')})$`, 'i')

  $('form').each(function () {
    const hasAction = typeof $(this).attr('action') !== 'undefined'
    const action = hasAction ? $(this).attr('action') : document.location.href
    const method = typeof $(this).attr('method') !== 'undefined' ? $(this).attr('method').toLowerCase() : 'get'

    const urlParts = parseUrl(action)

    if (method === 'get' && domainPattern.test(urlParts.host)) {
      if (hasAction) {
        $(this).attr('action', cacheControlForceLink(action))
      } else if ($(this).find(`input[name="${cacheControl.query_name}"]`).length <= 0) {
        const input = `<input type="hidden" name="${cacheControl.query_name}" value="1" />`
        $(this).prepend(input)
      }
    }
  })
}

function cacheControlInit() {
  cacheControlParseLinks()
  cacheControlParseForms()
}

$(document).on('ready ajaxComplete', () => {
  if (typeof cacheControl !== 'undefined' && cacheControl.enabled == 1) {
    cacheControlInit()
  }
})
